<template>
  <div class="sleepTestDetail" v-cloak>
    <v-container>
      <v-row class="sleepTestDetail_top">
        <v-card
          class="sleepTestDetail_main"
          :img="isPc ? getSleepTest.imageUrl2Pc : getSleepTest.imageUrl2Sp"
        >
          <!-- <p class="sleepTestDetail_sleepTestDesc">
            <span class="sleepTestDetail_title">{{ getSleepTest.name }}</span
            ><br />
            <span
              class="sleepTestDetail_descLine"
              v-for="item in getSleepTest.introduces"
              :key="item"
              >{{ item }}</span
            >
          </p> -->
        </v-card>
      </v-row>
      <v-row class="sleepTestDetail_cont">
        <v-col
          lg="12"
          md="12"
          sm="12"
          cols="12"
          v-for="(item, index) in getSleepTest.contents"
          :key="item.id"
          class="sleepTestDetail_movieItem"
        >
          <v-card
            class="sleepTestDetail_content"
            v-on:click="toMoviePath(index)"
          >
            <v-img class="sleepTestDetail_img" :src="item.imageUrl"></v-img>
            <p class="sleepTestDetail_movieInfo">
              <span class="sleepTestDetail_movieDeskLine">{{
                item.title
              }}</span>
            </p>
            <div class="arrow_right"></div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SleepTestDetail",
  computed: {
    ...mapGetters(["getSleepTest"]),
  },
  data: function () {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
      isPc: window.innerWidth >= 800,
    };
  },
  methods: {
    // linkToOtherWindow(url) {
    //   window.open(url, '_blank')
    // }
    toMoviePath(index) {
      this.$store.commit("setValueToSleepTestIndex", index);
      this.$router.push("/sleepTestMovie");
      window.scrollTo(0, 0);
    },
    backPage() {
      this.$router.back();
      window.scrollTo(0, 0);
    },
    handleResize() {
      // resizeのたびにこの部分が発火するので、ここでやりたいことをやる
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.isPc = this.width >= 800;
    },
  },
  mounted: function () {
    this.handleResize(); //ページ表示時に実行させる
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
<style lang="scss" scoped>
$xs: "320px";
$sm: "480px";
$md: "800px";
.sleepTestDetail {
  background: #5592c6;
  min-height: calc(100vh - 96px);
  &_logo {
    width: 160px;
  }
  &_menuTtl {
    padding-left: 50px;
    padding-right: 50px;
  }
  &_sleepTestDesc {
    margin-top: 16px;
    font-size: 20px;
    font-weight: 600;
    // padding-right: 40%;
    margin-left: 45%;
    letter-spacing: 0.04em;
    color: #1d64a1;
    line-height: 1.6;
    @media screen and (max-width: $md) {
      font-size: 14px;
      // margin-left: 4px;
      margin-left: 45%;
    }
    @media screen and (max-width: $sm) {
      // font-size: 14px;
      // margin-left: 4px;
      // margin-left: 45%;
      line-height: 1.4;
      margin-left: 44%;
    }
  }
  &_movieInfo {
    display: table;
    margin-top: 16px;
    font-weight: 600;
    padding-left: 1%;
    width: 55%;
    letter-spacing: 0.04em;
    color: #1d64a1;
    line-height: 1.6;
  }
  &_descLine {
    display: inline-block;
    font-size: 20px;
    @media screen and (max-width: $sm) {
      display: inline-block;
      font-size: 10px;
    }
  }
  &_movieDeskLine {
    display: table-cell;
    vertical-align: middle;
    font-size: 21px;
    padding-right: 9%;
    @media screen and (max-width: $sm) {
      display: table-cell;
      font-size: 14px;
    }
  }
  &_title {
    font-size: 28px;
    font-weight: bold;
    @media screen and (max-width: $md) {
      font-size: 24px;
    }
    @media screen and (max-width: $sm) {
      font-size: 14px;
    }
  }
  &_top {
    max-width: 980px;
    margin: 0 auto !important;
  }
  &_cont {
    padding: 48px;
    background: rgba(0, 0, 32, 0.2);
    border-radius: 6px;
    margin: 0 auto !important;
    max-width: 980px;
    @media screen and (max-width: $md) {
      padding: 6px;
    }
  }
  &_main {
    background: #fff;
    background-size: 40%;
    height: 21em;
    margin-bottom: 20px;
    width: 100%;
    @media screen and (max-width: 1263px) {
      height: 19em;
      margin-bottom: 10px;
      background-position: right top;
      .btn_next {
        margin-top: 0;
      }
    }
    @media screen and (max-width: 867px) {
      height: 18em;
      margin-bottom: 10px;
      background-position: right top;
      .btn_next {
        margin-top: 0;
      }
    }
    @media screen and (max-width: $md) {
      height: 70vw !important; // SP版画像アスペクト比参考
      box-shadow: none;
      margin-bottom: 20px;
      background-position: right top;
      .btn_next {
        margin-top: 0;
      }
    }
    @media screen and (max-width: $sm) {
      height: 70vw !important; // SP版画像アスペクト比参考
      box-shadow: none;
      margin-bottom: 20px;
      .btn_next {
        margin-top: 0;
      }
    }
  }
  &_content {
    display: flex;
    background: #fff;
    background-size: 40%;
    // padding: 48px;
    @media screen and (max-width: $md) {
      // padding: 16px;
      background-position: right top;
      .btn_next {
        margin-top: 0;
      }
    }
  }
  &_card {
    padding: 48px;
    @media screen and (max-width: $md) {
      padding: 16px;
    }
    p {
      margin: 0;
    }
  }
  &_card-disabled {
    opacity: 0.7;
  }
  &_cardTtl {
    text-align: center;
    font-size: 24px;
    color: #5592c6;
    font-weight: bold;
    @media screen and (max-width: $md) {
      font-size: 20px;
    }
  }
  &_desc {
    font-size: 15px;
    margin-top: 8px !important;
    @media screen and (max-width: $md) {
      font-size: 13px;
      margin-top: 0 !important;
    }
  }
  &_img {
    width: 40%;
  }
  &_movieItem {
    padding: 6px 16px;
  }
}
.cards {
  margin-top: 100px;
  color: #fff;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 48px;
}
.arrow_right::after {
  /* くの字の表示設定 */
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 3%;
  width: 25px; /* くの字を山なりに見た時、左側の長さ */
  height: 25px; /* くの字を山なりに見た時、右側の長さ */
  border-top: 3px solid rgb(150, 150, 150); /* くの字を山なりに見た時、左側の太さと色 */
  border-right: 3px solid rgb(150, 150, 150); /* くの字を山なりに見た時、右側の太さと色 */
  transform: rotate(45deg); /* くの字の向き */
  @media screen and (max-width: $sm) {
    width: 15px; /* くの字を山なりに見た時、左側の長さ */
    height: 15px; /* くの字を山なりに見た時、右側の長さ */
  }
}
.btn_layout {
  text-align: center;
}

[v-cloak] {
  display: none;
}
</style>
